interface FormatNumberSettings {
  digits?: { min?: number; max?: number }
  prefix?: string
}

export function formatNumber(num: number | undefined | null | string, settings?: FormatNumberSettings): string {
  const isNullOrUndefined = num === null || num === undefined
  if (isNullOrUndefined) return 'N/A'

  const isNeitherStringNorNumber = typeof num !== 'string' && typeof num !== 'number'
  if (isNeitherStringNorNumber) return 'N/A'

  const isString = typeof num === 'string'
  if (isString) {
    const validNumber = !!num && !Number.isNaN(Number(num))
    if (!validNumber) return 'N/A'
  }

  const { digits, prefix }: FormatNumberSettings = {
    digits: {
      min: settings?.digits?.min ?? 0,
      max: settings?.digits?.max ?? 2,
    },
    prefix: settings?.prefix ?? null,
  }

  const fractionDigits = {
    minimumFractionDigits: digits.min,
    maximumFractionDigits: digits.max,
  }

  return `${prefix ?? ''}${Number(num)?.toLocaleString('no-NO', fractionDigits)}`
}
